/* Angular Component */
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ExternalMAMServiceProvider } from "app/js/src/domain/external-mam/external-mam-service-provider";

@Component({
  selector: "external-mam-providers-card",
  templateUrl: "./external-mam-providers-card.component.html",
  styleUrls: ["./external-mam-providers-card.component.scss"],
})
export class ExternalMAMProvidersCardComponent {
  constructor(private sanitizer: DomSanitizer) {}
  @Input()
  provider: ExternalMAMServiceProvider;
  @Input()
  providerId: string = null;
  @Output()
  private goTo = new EventEmitter();

  displayLogo(logo) {
    return this.sanitizer.bypassSecurityTrustUrl(
      `data:image/svg+xml;base64,${logo}`,
    );
  }
  onClick() {
    this.goTo.emit();
  }
}
